module.exports = __webpack_public_path__ + "static/media/electricalAppliance.fe90ac42.svg";